module.exports = __webpack_public_path__ + "static/media/project-thailande.485b4313.png";